"use client";

import { Paper, PaperProps } from "@mui/material";
import { ReactNode } from "react";

export interface SurfaceCardProps extends Omit<PaperProps, "children"> {
  children?: ReactNode;
  padded?: boolean;
}

export function SurfaceCard({ children, padded = true, sx, className, ...paperProps }: SurfaceCardProps) {
  return (
    <Paper
      variant="outlined"
      className={className}
      sx={{
        borderColor: "var(--tc-border)",
        borderRadius: "var(--tc-radius-lg)",
        boxShadow: "var(--tc-shadow-sm)",
        transition: "box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out",
        ...(padded ? { p: 3 } : undefined),
        ...sx,
      }}
      {...paperProps}
    >
      {children}
    </Paper>
  );
}
